import { render, staticRenderFns } from "./customerCenter.vue?vue&type=template&id=31294fb1&scoped=true&"
import script from "./customerCenter.vue?vue&type=script&lang=js&"
export * from "./customerCenter.vue?vue&type=script&lang=js&"
import style0 from "./customerCenter.vue?vue&type=style&index=0&id=31294fb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31294fb1",
  null
  
)

export default component.exports